<div *ngIf="! configs['isGrid']" [formGroup]="formGroup">
    <span>
        <div *ngIf="!!configs['isReadOnly']"
            style="position: absolute; z-index: 500; opacity: 0.3; background-color: #777; height: 100%; width: 100%;">
        </div>
        <input [id]="configs['id']" [owlDateTime]="dtf" [min]="configs['minDate']" [max]="configs['maxDate']"
            [placeholder]="configs['placeholder']" [formControlName]="configs['id']" style="width: 85%;"
            (dateTimeInput)="onDateTimeInput($event)" (blur)="onBlurInput($event)" (focus)="onFocus()"
            [disabled]="!!configs['isReadOnly']" (dateTimeChange)="onDateTimeChange($event)">
    </span>
    <span class="cal_icon" [owlDateTimeTrigger]="dtf"><i class="fa fa-calendar" style="font-size: 20px;"></i></span>
    <owl-date-time #dtf [pickerType]="configs['pickerType']" (afterPickerOpen)="onClickPicker()"
        [startAt]="configs['startAt'] ? configs['startAt'] : (configs['minDate'] ? configs['minDate'] : null)"
        [disabled]="!!configs['isReadOnly']">
    </owl-date-time>
    <!-- <owl-date-time-inline [formControlName]="configs['id']"></owl-date-time-inline> -->
</div>
<div *ngIf="configs['isGrid']">
    <input [id]="configs['id']" [owlDateTime]="dtg" [(ngModel)]="defaultDt" [min]="configs['minDate']"
        [max]="configs['maxDate']" [placeholder]="configs['placeholder']" style="width: 85%;"
        (dateTimeChange)="onDateTimeChange($event)" (blur)="onBlurInput($event)" (focus)="onFocus()"
        (dateTimeInput)="onDateTimeInput($event)" (keydown)="onKeyUp($event)">
    <span class="cal_icon" [owlDateTimeTrigger]="dtg"><i class="fa fa-calendar" style="font-size: 20px;"></i></span>
    <owl-date-time #dtg [pickerType]="configs['pickerType']" (afterPickerClosed)="onAfterPickerClosed($event)">
    </owl-date-time>
</div>